import { useSearch } from 'src/hooks/use-search';
import { SANDBOX_DEVICES } from './sandbox-devices';

export const useCurrentZoneSandboxObj = () => {
  const [searchParams] = useSearch();

  const currentZoneSandboxObj = SANDBOX_DEVICES.find((device) => device.id === searchParams?.device?.id);

  return currentZoneSandboxObj;
};
